/* ADMIN REDUX */

const DEFAULT = {
    id: 0,
    name: "",
    image: null,
    access: "",
    isSuperAdmin: false,
}

const admin = (state = DEFAULT, action) => {

    switch (action.type) {

        case "SET_ADMIN":
            return action.payload

        default:
            return state

    }
}

export default admin